/**
 * Visible FAQs, keyed by page path. A page renders them from here and schema.ts emits FAQPage from
 * the same data, so markup and page text cannot drift apart. No page shows an FAQ today, so this is
 * empty (and no FAQPage is emitted).
 */
export type Faq = { q: string; a: string };

export const faqsByPath: Record<string, Faq[]> = {};
